import { render, staticRenderFns } from "./ProcessingPurchaseOrdersStatus.vue?vue&type=template&id=b33165b4&scoped=true"
import script from "./ProcessingPurchaseOrdersStatus.vue?vue&type=script&lang=ts"
export * from "./ProcessingPurchaseOrdersStatus.vue?vue&type=script&lang=ts"
import style0 from "./ProcessingPurchaseOrdersStatus.vue?vue&type=style&index=0&id=b33165b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33165b4",
  null
  
)

export default component.exports